/** Detect macOS / iOS for native overlay scrollbars vs custom webkit styling. */
export function detectMacOS(): boolean {
    if (typeof navigator === 'undefined') {
        return false;
    }

    const uaData = (navigator as Navigator & { userAgentData?: { platform?: string } }).userAgentData;
    if (uaData?.platform === 'macOS') {
        return true;
    }

    return /Mac|iPhone|iPad|iPod/i.test(navigator.platform)
        || /Mac OS X/i.test(navigator.userAgent);
}
